import { gql } from '@apollo/client'

export type {
  FieldCarbonEmissions,
  FieldCarbonEmissionsVariables,
  LotCarbonEmissions,
  LotCarbonEmissionsVariables,
  UpdateFieldCarbonConsumption,
  UpdateFieldCarbonConsumptionVariables,
} from './types/carbonEmissions.graphql'

export const FIELD_CARBON_EMISSIONS = gql`
  query FieldCarbonEmissions($fieldId: Int!, $seasonId: Int!) {
    field(id: $fieldId) {
      carbonEmissions(seasonId: $seasonId) {
        fuelConsumptionLiters
        electricityConsumptionKwh
        methaneCo2eKg
        nitrousOxideCo2eKg
        carbonDioxideCo2eKg
        totalCo2eKg
      }
    }
  }
`

export const UPDATE_FIELD_CARBON_CONSUMPTION = gql`
  mutation UpdateFieldCarbonConsumption(
    $fieldId: Int!
    $seasonId: Int!
    $fuelConsumptionLiters: Float
    $electricityConsumptionKwh: Float
  ) {
    updateFieldCarbonConsumption(
      fieldId: $fieldId
      seasonId: $seasonId
      fuelConsumptionLiters: $fuelConsumptionLiters
      electricityConsumptionKwh: $electricityConsumptionKwh
    ) {
      success
    }
  }
`

export const LOT_CARBON_EMISSIONS = gql`
  query LotCarbonEmissions($lotId: Int!) {
    lot(id: $lotId) {
      carbonEmissions {
        methaneCo2eKg
        nitrousOxideCo2eKg
        dailyMethaneEmissions {
          date
          daysSinceEmergence
          methaneCo2eKg
        }
      }
    }
  }
`
